import { render } from "./ErrorScreen.vue?vue&type=template&id=9b0c12b8&scoped=true"
import script from "./ErrorScreen.vue?vue&type=script&lang=js"
export * from "./ErrorScreen.vue?vue&type=script&lang=js"

import "./ErrorScreen.vue?vue&type=style&index=0&id=9b0c12b8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.2.47_vue@3.2.47_webpack@5.90.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b0c12b8"]])

export default __exports__